import React from 'react';
import { productCharPersonalizationEnabled } from '../productPersonalization';
import './char-picker.css';

/** Subtle “monogram” tag on product images in grids. */
export default function ProductLetterRibbon({ product, className = '' }) {
  if (!productCharPersonalizationEnabled(product)) return null;
  return (
    <span className={`product-letter-ribbon ${className}`.trim()} aria-hidden>
      <span className="product-letter-ribbon__spark">✦</span>
      Monogram
    </span>
  );
}
